import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAngemeldet } from "./sitzung";
import { db, supabase } from "./supabase";

/* Gemerkte Ansichten je Person (app_ansichten, BAUPLAN-STATUS-IN-LISTEN.md Abschnitt 4, ADR-023), zum Beispiel die Gruppierung im
   Sprint und in Meine Woche. Gilt auf allen Geräten. Ohne gemerkten Wert gilt die Vorgabe. Fehlt die Tabelle noch (die Minuten nach dem
   Deploy, bevor die Migration läuft) oder geht das Lesen oder Speichern schief, gilt still die Vorgabe oder die Wahl dieser Sitzung,
   ohne Fehlermeldung: Eine Ansicht ist es nicht wert, jemanden zu stören. */

/** Wert und Setzen einer gemerkten Ansicht. Nur Werte aus `erlaubt` gelten, alles andere fällt auf die Vorgabe zurück. */
export function useAnsicht<T extends string>(schluessel: string, erlaubt: readonly T[], vorgabe: T): [T, (neu: T) => void] {
  const { person } = useAngemeldet();
  const qc = useQueryClient();
  const key = ["ansicht", person.id, schluessel];
  const gemerkt = useQuery({
    queryKey: key,
    enabled: !!supabase,
    retry: false,
    staleTime: 5 * 60_000,
    queryFn: async (): Promise<unknown> => {
      const { data, error } = await db().from("app_ansichten").select("wert").eq("person", person.id).eq("schluessel", schluessel).maybeSingle();
      return error ? null : (data?.wert ?? null);
    },
  });
  const roh = gemerkt.data;
  const wert = typeof roh === "string" && (erlaubt as readonly string[]).includes(roh) ? (roh as T) : vorgabe;

  function setzen(neu: T) {
    // Ein Lesen, das noch läuft, darf die neue Wahl nicht überschreiben
    void qc.cancelQueries({ queryKey: key });
    qc.setQueryData(key, neu);
    if (!supabase) return;
    // Sofort speichern. Geht es schief, bleibt die Wahl für diese Sitzung.
    void db()
      .rpc("app_ansicht_setzen", { p_schluessel: schluessel, p_wert: neu })
      .then(
        () => undefined,
        () => undefined,
      );
  }

  return [wert, setzen];
}
